import React from 'react'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from '../../../Dropdown/DropdownTooltip/DropdownTooltip.scss'

type StateType = {
  opened: boolean
}

export type DropdownMenuButtonConfig = {
  title: string,
  icon?: JSX.Element,
  callback: () => void
}

type PropType = {
  buttonConfig: DropdownMenuButtonConfig[]
  align: 'left' | 'right'
}

const defaultProps: Partial<PropType> = {
  buttonConfig: [],
  align: 'left'
}

type OwnProps = PropType & Readonly<typeof defaultProps>

// TODO: ARIA and dynamic position for `.dropdown_pane`
export default class DropdownMenu extends React.Component<OwnProps, StateType> {
  state = {
    opened: false
  }

  toggleOpen = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    this.setState(prevState => ({
      opened: !prevState.opened,
    }))
  }

  hide = () => {
    if (this.state.opened) {
      this.setState({
        opened: false
      })
    }
  }

  render() {
    const { align } = this.props
    const { opened } = this.state

    return (
      <div className={cn(cl.dropdownContainer, cl.dropdownTooltip, opened && cl.dropdownContainerIsOpened)}>
        <div className={cl.dropdown__toggler}>
          <button className={cl.iconContainer} onClick={this.toggleOpen}>
            <span
              className={cg.showForSr}
              tabIndex={-1}
              aria-label="Open"
            />

            <span aria-hidden="true">
              {this.props.children}
            </span>
          </button>
        </div>

        {opened && (
          <React.Fragment>
            <div className={cl.dropdown__overlay} onClick={this.toggleOpen} />

            <ul className={cn(cl.foldable, cl.dropdown__pane, align === 'right' ? cl.dropdown__paneAlignRight : {})}>
              {this.props.buttonConfig.map((config, index) => {
                const callback = (e:React.MouseEvent) => { e.preventDefault(); e.stopPropagation(); config.callback() }
                return (
                  <li key={`shoppingList_${index}`}>
                    <button className={cn(cg.gridX, cg.alignMiddle, cl.dropdownButton)} onClick={callback}>
                      {config.icon && (
                      <span className={cn(cg.cell, cg.shrink)}>
                        {config.icon}
                      </span>
                      )}

                      <span className={cn(cg.cell, cg.auto)}>
                        {config.title}
                      </span>
                    </button>
                  </li>
                )
              })}

            </ul>
          </React.Fragment>
        )}
      </div>
    )
  }
}
